import React, { useEffect, useLayoutEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setStepperState } from '../../features/stepper/stepperSlice';
import { Box, Fade, Rating, Typography } from '@mui/material';
import { CustomContainer } from '../../components/CustomContainer';
import { StepperCard } from '../../components/StepperComponent';
import { colors } from '../../styles/colors';
import FindHolidayWidget from '../../components/FindHolidayWidget';
import { setIsClickedFilters, setIsHolidayApiCall, setPosition, setShowPopup } from '../../features/commonState';
import { getLocalStorage, getSessionStorage } from '../../helpers/storage';
import { useAppSelector } from '../../hooks/useAppReducer';
import { useLocation } from 'react-router-dom';
import useWindowWidth from '../../hooks/useWindowWidth';
import Image from "../../components/Image";
import { ReactComponent as RightChevron } from "../../assets/icons/RightChervon.svg";
import dayjs from "dayjs";
import StarIcon from "@mui/icons-material/Star";
import ReturnToOffer from '../../components/ReturnToOffer';
import { getCookie } from '../../helpers/cookieUtils';
const Search = () => {
    let existingData: any[] = [];
    const cookieData = getCookie("sharedCookieData");
    if (cookieData) {
        try {
          const parsed = JSON.parse(decodeURIComponent(cookieData));
          existingData = Array.isArray(parsed) ? parsed : [parsed];
        } catch (e) {
          existingData = [];
        }
    }
    // const popupData = JSON.parse(getLocalStorage("searchCriteria") || "{}");
    const hasPopupData = existingData && Object.keys(existingData).length > 0;
    const { storePayload ,showPopup} = useSelector((state: any) => state.commonState);
    const windowWidth = useWindowWidth()
    const dispatch = useDispatch();


    const { holidayPackage, filteredHolidayPackage } = useAppSelector((state) => state.holidayPackage);

    useEffect(() => {
        dispatch(setShowPopup(hasPopupData))
        dispatch(setStepperState(0));
    }, [dispatch]);

    const getPosition = (data?: any, isButtonClicked?: boolean, filterApply?: any) => { }


    useEffect(() => {
        if (window.innerWidth < 1024) {
            if (getSessionStorage("click") === "false") {
                getPosition(filteredHolidayPackage, false, true)
            }
        }
    }, [window.innerWidth, filteredHolidayPackage, getSessionStorage("click")])
    return (
        <Box position='relative'>
            <Box
                mb={{ xs: 1, lg: '30px', sm: '20px' }}
                pt={{ xs: windowWidth < 376 ? '130px' : '70px', xl: "10px", lg: '20px', md: '30px', sm: '60px' }}
            >
            </Box>
            <Box>
                <CustomContainer >
                    <StepperCard />
                </CustomContainer>
                <Box bgcolor={colors.basics.secondary} sx={{ mt: { xl: "35px", xs: '20px' }, pb: { md: '35px', xs: '20px' }, pt: { md: '35px', xs: '20px' } }}>
                    <CustomContainer style={{ maxWidth: '1340px !important' }}>
                        <Box>
                            <Typography variant='h1' fontSize='28px' fontWeight={600} lineHeight='44px' mb='15px'>
                                Find your perfect holiday
                            </Typography>
                            {window.location.host.includes("localhost") && <h2 style={{ marginBottom: "10px" }}> Search date after 4 months</h2>}
                            <FindHolidayWidget
                                setIsHolidayApiCall={setIsHolidayApiCall}
                                setIsClickedFilters={setIsClickedFilters}
                                getPosition={getPosition}
                            />
                        </Box>
                    </CustomContainer>
                </Box>
                {
                   ( holidayPackage?.Packages?.results?.length  == 0 || storePayload ==undefined ) ?  (
                        <>
                        <Typography variant='h1' marginTop={{
                          sm: '80px', xs: 6
                        }} textAlign='center' color={colors.basics.primary} >
                          Unfortunately, no results were returned for the package you have searched.
                        </Typography>
                        <Typography variant='h1' marginBottom={{
                          sm: 0, xs: "20px"
                        }} textAlign='center' color={colors.basics.primary} >
                          Please search again for alternatives.
                        </Typography>
                      </>)
                      :   <Typography my={{ xs: 6, sm: '80px' }}
                    mx={{ xs: 2, sm: '0' }}
                    // marginTop={{
                    //   sm: 0, xs: "20px"
                    // }}
                    variant='h1' textAlign='center' color={colors.basics.primary} >
                    Please complete the form above to explore our range of holidays.
                </Typography>
                }             
                <Box >
                    {showPopup &&(
                        <ReturnToOffer />
                    )}
                </Box>

                {/* <HotelComponent /> */}
            </Box>
        </Box>
    )
}

export default Search